import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Calendar, Trophy, BarChart2, Users, RotateCcw, Clock } from 'lucide-react';

/**
 * TabBar component for app navigation
 * Styled with fitness app inspired design
 */
const TabBar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Define tabs
  const tabs = [
    {
      id: 'schedule',
      path: '/schedule',
      label: 'Schedule',
      icon: <Calendar size={22} strokeWidth={2} />
    },
    {
      id: 'match',
      path: location.pathname.startsWith('/match/') ? location.pathname : '/schedule',
      label: 'Live',
      icon: <Clock size={22} strokeWidth={2} />,
      active: location.pathname.startsWith('/match/')
    },
    {
      id: 'teams',
      path: '/teams',
      label: 'Teams',
      icon: <Users size={22} strokeWidth={2} />
    },
    {
      id: 'leaderboard',
      path: '/leaderboard',
      label: 'Standings',
      icon: <Trophy size={22} strokeWidth={2} />
    },
    {
      id: 'past-matches',
      path: '/past-matches',
      label: 'History',
      icon: <RotateCcw size={22} strokeWidth={2} />
    },
    {
      id: 'analytics',
      path: '/analytics',
      label: 'Stats',
      icon: <BarChart2 size={22} strokeWidth={2} />
    }
  ];

  // Navigate to tab
  const goToTab = (path) => {
    navigate(path);
  };

  // Check if a tab is active
  const isActive = (tabId) => {
    if (tabId === 'match' && location.pathname.startsWith('/match/')) {
      return true;
    }

    const tab = tabs.find(t => t.id === tabId);
    return location.pathname === tab?.path;
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t dark:border-gray-800 z-10 pb-safe">
      <div className="max-w-xl mx-auto flex justify-around items-center">
        {tabs.map(tab => {
          const active = isActive(tab.id);

          return (
          <button
            key={tab.id}
            onClick={() => goToTab(tab.path)}
              className="relative flex flex-col items-center py-3 px-3 w-full"
            >
              {/* Active indicator */}
              {active && (
                <span className="absolute top-0 left-1/2 transform -translate-x-1/2 w-8 h-1 bg-primary-500 rounded-b-full" />
              )}

              <div className={`mb-1 transition-transform ${active ? 'transform scale-110' : ''}`}>
                <span className={`${
                  active
                    ? 'text-primary-500 dark:text-primary-400'
                    : 'text-gray-500 dark:text-gray-400'
                }`}>
                  {tab.icon}
                </span>
              </div>

              <span className={`text-xs font-medium font-display tracking-wide transition-colors ${
                active
                  ? 'text-primary-600 dark:text-primary-400'
                : 'text-gray-500 dark:text-gray-400'
              }`}>
                {tab.label}
              </span>
          </button>
          );
        })}
      </div>
    </div>
  );
};

export default TabBar;
